module.exports = __webpack_public_path__ + "img/47_32.e4dd2631.png";